import Swup from "swup";
import SwupGiaPlugin from "@swup/gia-plugin";
import { initLazyLoad, refreshLazyLoad } from "./LazyLoad.js";

const logStyle_trans = "color: #1E90FF; font-weight: bold;";
let swupInstance = null;

const syncBodyPage = () => {
  const swupContainer = document.querySelector("#swup");
  const pageId = swupContainer?.dataset.pageId;

  if (pageId) {
    document.body.dataset.page = pageId;
  }
};

export default function initPageTransitions(components = {}) {
  if (swupInstance) return swupInstance;

  if (!document.querySelector("#swup")) return null;

  swupInstance = new Swup({
    containers: ["#swup"],
    plugins: [new SwupGiaPlugin({ components, firstLoad: true, log: true })],
  });

  syncBodyPage();
  initLazyLoad();

  swupInstance.hooks.on("content:replace", () => refreshLazyLoad());

  swupInstance.hooks.on("visit:start", (visit) => {
    // Extract pathname from visit object (handle both string and object forms)
    const url = visit.to?.url;
    const pathname = typeof url === "string" ? url : url?.pathname;

    if (pathname) {
      // Body data-page attr. updt. //
      const pageId = pathname.split("/").filter(Boolean)[0] || "home";
      document.body.dataset.page = pageId;

      // Nav link active state update //
      const navLinks = document.querySelectorAll('[data-ref="navLink"]');
      if (navLinks.length)
        navLinks.forEach((l) => {
          const linkId = l.dataset.id;
          if (linkId) l.dataset.active = linkId === pageId ? "true" : "false";
        });
    }
  });

  return swupInstance;
}
